import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";

import FnrIcon from "UI/FnrIcon";
import FnrPaymentMethodIcon from "UI/FnrPaymentMethodIcon";

PaymentMethod.propTypes = {
  paymentTypeIcon: PropTypes.string,
  paymentCardType: PropTypes.string,
};

export default function PaymentMethod({ paymentTypeIcon, paymentCardType }) {
  if (paymentCardType) {
    const cardType = paymentCardType.toLowerCase();
    const isBankAccount = cardType === "checking" || cardType === "savings";

    return (
      <CardIconWrapper $transparentBG={isBankAccount}>
        <FnrPaymentMethodIcon cardType={paymentCardType} />
      </CardIconWrapper>
    );
  }

  return (
    <Wrapper>
      <FnrIcon icon={`fa-${paymentTypeIcon} fas`} />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  border-radius: 6px;
  width: 36px;
  height: 36px;
  font-size: 20px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  flex-shrink: 0;
  background: #fff;
  color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid var(--textPrimary);
  background: var(--textPrimary);
  color: var(--textInverse);
  .mobile & {
    background: #fff;
    border: 2px solid #fff;
    color: var(--textPrimary);
  }
`;

const CardIconWrapper = styled(Wrapper)`
  border: none;
  overflow: hidden;
  background: ${(p) =>
    p.$transparentBG ? "transparent" : "var(--textPrimary)"};
`;
